<canvas 
[style.width.px]="width" 
[style.height.px]="height" 
#canvas class="card-canvas"></canvas>
